var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{'table-header__th-name': _vm.isSort},on:{"click":_vm.onToggleSort}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),(_vm.isShowIconSort)?_c('i',{class:'th_arrow fa ' + _vm.sortStateActiveIcon}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }